export default __webpack_public_path__ + "e1c8c608f697621d53b69aaa86376ea5.svg";